import { apiClient } from '@/client'
import router from '@/router'
import { checkToken, checkScope, getProfile, getToken } from '@/utils'

export default {
  namespaced: true,
  state: {
    loggedIn: false,
    jwt: getToken(),
    profile: getProfile(),
    authError: null,
    hasError: false,
    loading: false,
  },
  getters: {
    token: state => state.jwt,
    profile: state => state.profile,
    authError: state => state.authError,
    hasError: state => state.hasError,
    isLoading: state => state.loading,
    loggedIn: state => state.loggedIn,
    scope: state => state.profile.scope || [],
  },
  mutations: {
    UPDATE_TOKEN (state, newToken) {
      localStorage.setItem('_gespantoken', newToken)
      state.jwt = newToken
      state.profile = getProfile(newToken)
      apiClient.setAPIKey(newToken)
      state.loggedIn = true
    },
    REMOVE_TOKEN (state) {
      localStorage.removeItem('_gespantoken')
      state.jwt = null
      state.profile = {}
      apiClient.clearAPIKey()
      state.loggedIn = false
    },
    CHECK_AUTH (state, payload) {
      //
    },
    AUTH_SUCCESS (state) {
      state.loading = false
      state.loggedIn = true
      state.hasError = false
      console.log('login success')
    },
    AUTH_ERROR (state, payload) {
      state.authError = payload
      state.hasError = true
      state.loading = false
      state.loggedIn = false
    },
    AUTH_REQUEST (state, payload) {
      state.authError = false
      state.loading = true
      state.loggedIn = false
    },
  },
  actions: {
    checkAuth: ({ commit, dispatch }, token) => {
      commit('CHECK_AUTH', token)
      return new Promise((resolve, reject) => {
        if (checkToken(token)) {
          apiClient.setAPIKey(token)
          commit('AUTH_SUCCESS')
          commit('ui/LOAD_STATE', {}, {root: true})
          resolve(true)
        } else {
          reject(new Error('Invalid token.'))
        }
      })
    },

    checkAuthnz: ({ commit, dispatch }, {required, available}) => {
      return new Promise((resolve, reject) => {
        if (checkScope(required, available)) {
          resolve(true)
        } else {
          reject(new Error('Unauthorized.'))
        }
      })
    },

    login: ({ commit }, creds) => {
      return new Promise((resolve, reject) => {
        commit('AUTH_REQUEST', creds)
        apiClient.login(creds)
          .then(apiKey => {
            commit('AUTH_SUCCESS')
            commit('UPDATE_TOKEN', apiKey)
            commit('ui/LOAD_STATE', {}, {root: true})
            resolve(true)
          })
          .catch(e => {
            console.log(e)
            commit('AUTH_ERROR', e)
            reject(e)
          })
      })
    },

    logout: ({ commit }) => {
      apiClient.logout()
        .then(response => {
          commit('REMOVE_TOKEN')
          commit('ui/DUMP_STATE', {}, {root: true})
          router.push({
            name: 'login',
            query: { redirect: '/' },
          })
        })
    },
  },

}
